module.exports = __webpack_public_path__ + "img/videoRecord.c30d7189.png";